// Libs
import { useState, useRef } from 'react';
import { notification } from 'antd';
// Services
import { ApiServiceV2 } from 'services';
// Validators
import { requestGenerateReportValidator } from 'screens/Reports/reports.validator';

import { archiveRequest } from './archiveRequest';

const useGenerateReportSubmit = () => {
	const pendingRequest = useRef(null);
	const [isLoading, setIsLoading] = useState(false);

	const submitReport = ({ payload, reportParams, onSuccess }) => {
		const error = requestGenerateReportValidator(payload, reportParams);
		if (error) {
			notification.warning({ message: error, className: 'notification-dark-style', duration: 5 });
			return;
		}

		setIsLoading(true);
		const prepared = archiveRequest(payload, pendingRequest.current);
		pendingRequest.current = prepared.pending;
		ApiServiceV2.post({ url: '/reports/generateReport', ...prepared.request })
			.then(response => {
				pendingRequest.current = null;
				notification.success({ message: response?.jobId ? 'Informe en preparación. Recibirá el correo cuando termine.' : 'Reporte en camino!', className: 'notification-dark-style', duration: 5 });
				onSuccess?.();
			})
			.catch(() => {
				notification.error({ message: 'No se pudo generar el reporte', className: 'notification-dark-style', duration: 5 });
			})
			.finally(() => setIsLoading(false));
	};

	return { submitReport, isLoading };
};

export default useGenerateReportSubmit;
